import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DatePicker, DateRange } from "@/components/TxTable";
import { dateStr, daysAgoStr, todayStr } from "@/lib/format";

const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const lastMonths = () => {
  const [y, m] = todayStr().split("-").map(Number);
  return Array.from({ length: 12 }, (_, i) => { const d = new Date(y, m - 1 - i, 1); return { v: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`, l: `${MONTHS[d.getMonth()]} ${d.getFullYear()}` }; });
};
const monthRange = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  const end = `${ym}-${String(last).padStart(2, "0")}`;
  return { start: `${ym}-01`, end: end > todayStr() ? todayStr() : end };
};

// modes: harian (today/single date), mingguan (last 7 days), bulanan (month picker), tanggal (custom range)
export const PeriodFilter = ({ onChange, modes = ["harian", "mingguan", "bulanan", "tanggal"], initial = "harian", testId = "period" }) => {
  const [mode, setMode] = useState(initial);
  const [day, setDay] = useState(todayStr());
  const [month, setMonth] = useState(todayStr().slice(0, 7));
  const [range, setRange] = useState({ start: daysAgoStr(29), end: todayStr() });
  useEffect(() => {
    if (mode === "harian") onChange({ start: day, end: day });
    else if (mode === "mingguan") onChange({ start: dateStr(new Date(Date.now() - 6 * 86400000)), end: todayStr() });
    else if (mode === "bulanan") onChange(monthRange(month));
    else onChange(range);
  }, [mode, day, month, range]); // eslint-disable-line react-hooks/exhaustive-deps
  const labels = { harian: "Harian", mingguan: "Mingguan", bulanan: "Bulanan", tanggal: "Pilih Tanggal" };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2" data-testid={testId}>
      <Tabs value={mode} onValueChange={setMode}>
        <TabsList className="h-11">{modes.map((m) => <TabsTrigger key={m} value={m} className="h-9" data-testid={`${testId}-${m}`}>{labels[m]}</TabsTrigger>)}</TabsList>
      </Tabs>
      {mode === "harian" && <DatePicker value={day} onChange={setDay} testId={`${testId}-day`} />}
      {mode === "bulanan" && (
        <Select value={month} onValueChange={setMonth}>
          <SelectTrigger className="h-11 w-[170px]" data-testid={`${testId}-month`}><SelectValue /></SelectTrigger>
          <SelectContent>{lastMonths().map((o) => <SelectItem key={o.v} value={o.v}>{o.l}</SelectItem>)}</SelectContent>
        </Select>
      )}
      {mode === "tanggal" && <DateRange start={range.start} end={range.end} onChange={(start, end) => setRange({ start, end })} testId={`${testId}-range`} />}
    </div>
  );
};
